import BaseListPresenter from "../../../base/BaseListPresenter";
import { aggregateUseCase } from "../../../usecases/object";
import AggregateUseCase from "../../../usecases/object/AggregateUseCase";

class BiomentricLogsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 50;
    this.where = { origin: { $ne: "DTR" } };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { timestamp: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      // const aggregateUseCase = new AggregateUseCase();
      this.findObjectUseCase.abort();
      const employees = await this.findObjectUseCase.execute("employees", {
        keys: ["Firstname", "Middlename", "surname", "biometricId"],
      });

      // Create a lookup map for faster matching
      const userMap = new Map(
        employees.map((employee) => [
          String(employee?.biometricId),
          [employee?.Firstname, employee?.Middlename, employee?.surname]
            .filter(Boolean)
            .join(" "),
        ]),
      );

      const objects = await this.findObjectUseCase.execute(collection, query);
      objects.forEach((object) => {
        object.pin = userMap.get(String(object.pin)) || "Invalid User";
        object.status =
          object.status !== undefined
            ? `F${Number(object.status) + 1}`
            : object.status;
      });
      this.objects = this.objects.concat(objects);
      this.view.setCount(this.count);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }
}
export default BiomentricLogsPresenter;
